import { Box, HStack, Text, VStack } from '@chakra-ui/react'

interface PillOption<T extends string> {
  id: T
  name: string
}

interface PillToggleGroupProps<T extends string> {
  label?: string
  options: PillOption<T>[]
  value: T
  onChange: (val: T) => void
  required?: boolean
}

function PillToggleGroup<T extends string>({ label, options, value, onChange, required }: PillToggleGroupProps<T>) {
  return (
    <VStack align="left" spacing="4px" width="100%">
      {label && (
        <Text textStyle="l-xs" color={required ? 'solid.700' : 'solid.500'} fontWeight={required ? '600' : undefined}>
          {label}
          {required && <Text as="span" color="primary.100"> *</Text>}
        </Text>
      )}
      <HStack spacing="8px" w="100%">
        {options.map((opt) => {
          const selected = value === opt.id
          return (
            <Box
              key={opt.id}
              as="button"
              type="button"
              flex="1"
              py="10px"
              px="16px"
              borderRadius="10px"
              border="1.5px solid"
              borderColor={selected ? 'primary.100' : 'solid.100'}
              bg={selected ? 'primary.0' : 'white'}
              color={selected ? 'primary.200' : 'solid.600'}
              fontWeight={selected ? '600' : '500'}
              fontSize="13px"
              transition="all 0.15s ease"
              _hover={{
                borderColor: 'primary.100',
                bg: 'primary.0',
              }}
              onClick={() => onChange(opt.id)}
            >
              {opt.name}
            </Box>
          )
        })}
      </HStack>
    </VStack>
  )
}

export default PillToggleGroup
export type { PillOption }
